import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CartaoFidelidade } from "@/features/cartao-fidelidade";

import { textoPremio } from "./Premios";

const DATAS = ["03/10", "09/10", "15/10", "21/10"];
const CARIMBOS = 6;

function Amostra({ t }) {
  return <span className="w-5 h-5 rounded-md shrink-0" style={{ background: `linear-gradient(135deg, ${t.c1}, ${t.c2})` }} />;
}

/**
 * O cartão como o cliente vê no cardápio, com o nome, o logo, o tema e o 1º
 * prêmio da tela. Simplificado em 24/10/2026 (dono): sem as variações animado /
 * parado / foto do WhatsApp e sem a barra de carimbos; o visual virou uma lista
 * suspensa logo abaixo do cartão.
 */
export default function Previa({ loja, tema, premios, temas, doNicho, onTema }) {
  const p = premios[0];
  const cartao = { carimbos: CARIMBOS, total: 10, bonus: 2, datas: DATAS,
    premio: { texto: p ? textoPremio(p) : tema.exemplo, foto: p?.foto } };

  return (
    <div className="space-y-3">
      <CartaoFidelidade loja={{ ...loja, tema }} cartao={cartao} animado carimboNovo={CARIMBOS} />
      <div className="space-y-1.5">
        <p className="text-xs font-medium">Visual do cartão</p>
        <Select value={tema.id} onValueChange={(id) => onTema(id === doNicho ? null : id)}>
          <SelectTrigger className="h-10" data-e2e="tema-escolher">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {temas.map((t) => (
              <SelectItem key={t.id} value={t.id} data-e2e={`tema-${t.id}`}>
                <span className="flex items-center gap-2">
                  <Amostra t={t} /> {t.emoji} {t.nome}
                  {t.id === doNicho && <span className="text-[10px] font-bold uppercase text-muted-foreground">· seu tipo</span>}
                </span>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <p className="text-[11px] text-muted-foreground">Já vem com o tema do seu Tipo de estabelecimento (Preferências).</p>
      </div>
    </div>
  );
}
